module.exports = __webpack_public_path__ + "img/sira_no.3beec6d3.png";